<template>
  <Modal :isOpen="show" :title="isLogin === 'login' ? 'Login' : 'Register'" @close="close">
    <Tabs
      v-model="isLogin"
      :tabs="[
        { label: 'Login', value: 'login' },
        { label: 'Register', value: 'register' }
      ]"
    />

    <form @submit.prevent="handleSubmit" class="auth-form">
      <div v-if="error" class="error">
        {{ error }}
      </div>
      <FormGroup label="Email" for="email" description="Enter your email address.">
        <input type="email" id="email" v-model="form.email" required />
      </FormGroup>

      <FormGroup v-if="isLogin === 'register'" label="Name" for="name" description="Enter your full name.">
        <input type="text" id="name" v-model="form.name" required />
      </FormGroup>

      <FormGroup label="Password" for="password" description="Must be at least 6 characters.">
        <input type="password" id="password" v-model="form.password" required />
      </FormGroup>

      <FormGroup v-if="isLogin === 'register'" label="Confirm Password" for="confirmPassword" description="Repeat your password.">
        <input type="password" id="confirmPassword" v-model="form.confirmPassword" required />
      </FormGroup>

      <div class="form-actions">
        <button type="submit" class="btn-primary" :disabled="loading">
          {{ loading ? 'Processing...' : isLogin === 'login' ? 'Login' : 'Register' }}
        </button>
      </div>
    </form>

    <!--div class="divider">
      <span>or</span>
    </div>

    <div class="google-auth">
      <button @click="handleGoogleAuth" class="btn-google" :disabled="loading">
        <svg viewBox="0 0 24 24" class="google-icon">
          <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
          <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
          <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
          <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
        </svg>
        Continue with Google
      </button>
    </div-->
  </Modal>
</template>

<script>
import api from '../ApiClient.js';
import Modal from './Modal.vue';
import FormGroup from './FormGroup.vue';
import Tabs from './Tabs.vue';
import ThemeManager from '../ThemeManager.js';

export default {
  name: 'AuthModal',
  components: { Modal, FormGroup, Tabs },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLogin: 'login',
      form: {
        email: '',
        password: '',
        confirmPassword: '',
        name: ''
      },
      error: '',
      loading: false
    };
  },
  methods: {
    // Detect system dark theme preference
    getSystemTheme() {
      return ThemeManager.getSystemTheme();
    },

    resetForm() {
      this.form = {
        email: '',
        password: '',
        confirmPassword: '',
        name: ''
      };
      this.error = '';
      this.loading = false;
      this.isLogin = 'login';
    },
    close() {
      this.resetForm();
      this.$emit('close');
    },

    switchMode() {
      this.isLogin = this.isLogin === 'login' ? 'register' : 'login';
      this.resetForm();
    },

    async handleSubmit() {
      this.loading = true;
      this.error = '';

      // Validate passwords match for register
      if (this.isLogin === 'register' && this.form.password !== this.form.confirmPassword) {
        this.error = 'Passwords do not match';
        this.loading = false;
        return;
      }

      try {
        let data;
        if (this.isLogin === 'login') {
          data = await api.login(this.form);
        } else {
          // Include system theme preference for registration
          const registrationData = {
            ...this.form,
            darkTheme: this.getSystemTheme()
          };
          data = await api.register(registrationData);
        }

        // Store token and user data
        localStorage.setItem('authToken', data.token);
        localStorage.setItem('user', JSON.stringify(data.user));

        // Emit success event
        this.$emit('auth-success', data);
        this.resetForm();
        this.close();
      } catch (error) {
        this.error = error.message;
      } finally {
        this.loading = false;
      }
    },

    async handleGoogleAuth() {
      this.loading = true;
      this.error = '';

      try {
        // Get Google auth URL
        const data = await api.getGoogleAuthUrl();

        // Add redirect URI to the auth URL
        const redirectUri = encodeURIComponent(window.location.origin + '/auth-callback.html');
        const authUrl = `${data.authUrl}&redirect_uri=${redirectUri}`;

        // Redirect to Google OAuth
        window.location.href = authUrl;
      } catch (error) {
        this.error = error.message;
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.divider {
  text-align: center;
  margin: 1.5rem 0;
  position: relative;
}

.divider::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 1px;
  background: #eee;
}

.divider span {
  background: white;
  padding: 0 1rem;
  color: #666;
  font-size: 0.9rem;
}

.google-auth {
  margin-bottom: 1rem;
}

.btn-google {
  width: 100%;
  padding: 0.75rem;
  background: white;
  color: #333;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  transition: background-color 0.2s;
}

.btn-google:hover:not(:disabled) {
  background: #f8f9fa;
}

.btn-google:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.google-icon {
  width: 18px;
  height: 18px;
}
</style>
